<template>
  <div class="wrap">
    <!-- v-wechat-title="$route.meta.title=content.title" -->
    <div class="topicdetail" ></div>
    <div class="title">{{ title }}</div>
    <div v-html="content.content" class="contentbox"></div>
  </div>
</template>
<script>
import { getArticle } from '@/api/app'
export default {
  data(){
    return{
      content:'',
      title:''
    }
  },
  methods:{
    getDetail(id){
      const postarr ={
        id: id
      }
    getArticle(postarr).then(res=>{
        console.log(res)
        this.content = res
        this.title = res.title;
        this.$nextTick(function () {
          //dom已更新
        const videoList = document.querySelectorAll('video');
         console.log(videoList.length)
        for(let i =0;i<videoList.length;i++){
          // videoList[i].setAttribute('preload',true)
          // videoList[i].addEventListener('loadeddata', function () {
          //   // 截取视频第一帧
          //   var canvas = document.createElement('canvas');
          //   canvas.width = videoList[i].videoWidth ;
          //   canvas.height = videoList[i].videoHeight;
          //   canvas.getContext('2d').drawImage(videoList[i], 0, 0, canvas.width, canvas.height);
          //   var src = canvas.toDataURL('image/png');
          //   // 设置属性
          //   console.log(src)
          //   videoList[i].setAttribute('poster', http://dfosspic01.oss-cn-shenzhen.aliyuncs.com/dfcloud/pic/1629982185504_111.jpeg);
          // });
          // videoList[i].setAttribute('poster', 'http://dfosspic01.oss-cn-shenzhen.aliyuncs.com/dfcloud/pic/1629982185504_111.jpeg');
          videoList[i].setAttribute('preload',true)
          videoList[i].style.width='100%'
        }
        })
      })
    },
  },
  mounted(){
    const { query } = this.$route;
    const { id } = query;
    if(id){
      this.getDetail(id)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  // max-width: 750PX;
  margin: 0 auto;
  min-height: 100vh;
  font-size: 14Px;
  word-wrap: break-word;
  background-color: #f5f5f5;
  .contentbox{
    overflow-x: hidden;
    margin: 0 32px;
    padding-top: 50px;
  }
  .title {
    width: 686px;
    font-size: 32px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: #333333;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 43px;
    border-bottom: 1px dashed #999999;
  }
}
</style>